/* ============================================================
   CanineCeuticals custom JS (Alchemy 5.x)
   Ported from the 4.2.5 assets/custom.js. 5.x ships without jQuery, so the
   old jQuery snippets are rewritten in plain JS. Things the old file did by
   DOM-injection now live in the theme instead:
     - heading icons      -> section custom CSS (migration/migrate.py HEADING_ICONS)
     - footer signup / "Follow us" panel / footer logo bar -> sections/cc-footer-signup.liquid + footer.liquid
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  // Contact page intro line
  // (4.x keyed this on body#get-in-touch; 5.x has no body id, so match the page URL)
  var getInTouch = /^\/pages\/contact\/?$/.test(location.pathname) && document.querySelector('main h1');
  if (getInTouch) {
    getInTouch.insertAdjacentHTML('afterend', '<p style="font-weight: 400;">We are here to help and to answer any of your questions</p>');
  }

  // Product page: "FEATURES" rich text label
  document.querySelectorAll('.product-info p').forEach(function (p) {
    if (p.textContent.trim() === 'FEATURES') p.className = 'features-heading';
  });

  // External links open in a new tab
  var links = document.links;
  for (var i = 0; i < links.length; i++) {
    if (links[i].hostname && links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener nofollow';
    }
  }
});

/* ============================================================
   CanineCeuticals — resource gate (URL-matched + clickable cards)
   ------------------------------------------------------------
   Gated (Klaviyo signup): guides, webinars   Free: handouts, recipes

   - Gating is keyed on the URL (first path segment), not a class, so
     module/section-generated links gate with zero markup changes:
         <a href="/guides/...">  -> gated      <a href="/handouts/...">  -> free
   - For each gated link it also makes the card IMAGE clickable, by
     overlaying a transparent <span> (NOT a second <a href>) that fires
     the same gate. No extra link = no race, no bypass, no crawl dupe.
   - Optional per-link overrides: class="gated-resource", data-resource-type.

   GATED: click -> Klaviyo form to non-subscribers -> on submit the href
   opens -> Shopify redirect resolves it to the PDF.
   ============================================================ */
(function () {
  var CONFIG = {
    klaviyoFormId: 'XjaZZp',
    gatedTypes: ['guide', 'guides', 'webinar', 'webinars'],
    klaviyoReadyTimeoutMs: 1000,
    pdfOpenDelayMs: 400,
    listenerCleanupMs: 300000,

    // Clickable-image feature. Tighten cardSelectors to your real card
    // class once you inspect it (nearest matching ancestor wins).
    cardClickable: true,
    cardSelectors: '.multicolumn-card, .column, [class*="col"], li',
    mediaSelectors: '.media, .multicolumn__image, .image, .card__media'
  };

  document.addEventListener('DOMContentLoaded', function () {
    var s = document.createElement('style');
    s.textContent = '.gated-resource{cursor:pointer;}.cc-gate-cover{position:absolute;inset:0;z-index:2;display:block;cursor:pointer;}';
    document.head.appendChild(s);

    var links = document.querySelectorAll('a[href], a.gated-resource');
    for (var i = 0; i < links.length; i++) maybeWire(links[i]);
  });

  function maybeWire(link) {
    if (link.getAttribute('data-gate-wired')) return;
    var type = resourceType(link);
    if (!isGated(type) && !link.classList.contains('gated-resource')) return;
    link.setAttribute('data-gate-wired', '1');
    link.classList.add('gated-resource');
    var asset = assetUrl(link);
    wireGated(link, asset, type);
    if (CONFIG.cardClickable) makeImageClickable(link, asset, type);
  }

  // --- helpers --------------------------------------------------------------

  function resourceType(link) {
    var explicit = (link.getAttribute('data-resource-type') || '').toLowerCase().trim();
    if (explicit) return explicit;
    var href = link.getAttribute('href') || '';
    if (!href) return '';
    try {
      var path = href.charAt(0) === '/' ? href : new URL(href, location.origin).pathname;
      return (path.split('/').filter(Boolean)[0] || '').toLowerCase();
    } catch (e) { return ''; }
  }
  function isGated(type) { return CONFIG.gatedTypes.indexOf(type) !== -1; }
  function assetUrl(link) {
    return link.getAttribute('data-pdf-url') || link.getAttribute('href') || '';
  }

  // --- wiring ---------------------------------------------------------------

  function wireGated(link, asset, type) {
    if (asset) link.setAttribute('data-pdf-url', asset);
    link.removeAttribute('href');               // kills middle-click / new-tab bypass
    link.setAttribute('role', 'button');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      handleGatedClick(link.getAttribute('data-pdf-url') || asset, type);
      return false;
    });
  }

  function makeImageClickable(link, asset, type) {
    var card = link.closest(CONFIG.cardSelectors);
    if (!card) return;
    var img = card.querySelector('img');
    if (!img) return;
    var media = img.closest(CONFIG.mediaSelectors) || img.parentNode;
    if (!media || media.querySelector('.cc-gate-cover')) return;  // already covered

    var pos = window.getComputedStyle(media).position;
    if (pos === 'static') media.style.position = 'relative';

    var cover = document.createElement('span');
    cover.className = 'cc-gate-cover';
    cover.setAttribute('aria-hidden', 'true');  // text button stays the accessible control
    cover.addEventListener('click', function (e) {
      e.preventDefault();
      handleGatedClick(asset, type);
    });
    media.appendChild(cover);
  }

  // --- gate flow ------------------------------------------------------------

  function handleGatedClick(asset, type) {
    var handled = false;
    var fallback = setTimeout(function () {
      if (handled) return; handled = true; openForm(asset, type);
    }, CONFIG.klaviyoReadyTimeoutMs);

    if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
      window.klaviyo.isIdentified().then(function (identified) {
        clearTimeout(fallback); if (handled) return; handled = true;
        if (identified) openAsset(asset); else openForm(asset, type);
      }).catch(function () {
        clearTimeout(fallback); if (handled) return; handled = true; openForm(asset, type);
      });
    } else {
      clearTimeout(fallback); handled = true; openForm(asset, type);
    }
  }

  function openAsset(url) {
    if (!url) return;
    var w = window.open(url, '_blank');         // webview-blocked? navigate in place
    if (!w) window.location.href = url;
  }

  function openForm(asset, type) {
    waitForSubmit(asset);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', CONFIG.klaviyoFormId]);
  }

  function waitForSubmit(asset) {
    function onKlaviyoForm(e) {
      if (!e.detail) return;
      var isOurForm = !e.detail.formId || e.detail.formId === CONFIG.klaviyoFormId;
      if (e.detail.type === 'submit' && isOurForm) {
        cleanup();
        try {
          var email = e.detail.metaData && e.detail.metaData.$email;
          window.klaviyo = window.klaviyo || [];
          window.klaviyo.push(['track', 'Gated Resource Requested', {
            ResourceType: resourceTypeFromUrl(asset), ResourceUrl: asset, $email: email
          }]);
        } catch (err) { /* non-fatal */ }
        setTimeout(function () { openAsset(asset); }, CONFIG.pdfOpenDelayMs);
      }
    }
    function cleanup() { window.removeEventListener('klaviyoForms', onKlaviyoForm); }
    window.addEventListener('klaviyoForms', onKlaviyoForm);
    setTimeout(cleanup, CONFIG.listenerCleanupMs);
  }

  function resourceTypeFromUrl(url) {
    try {
      var path = url.charAt(0) === '/' ? url : new URL(url, location.origin).pathname;
      return (path.split('/').filter(Boolean)[0] || '').toLowerCase();
    } catch (e) { return ''; }
  }
})();
